const availableRendererIpcChannels = new Set()

export const store = {
  main: {
    availableRendererIpcChannels,
  },
}
